export const locale = {
  ru: {
    hasLogo: true,
    title: null,
    tag: 'Рассылка',
    text: `<p>Подпишитесь на&nbsp;<nobr>SOS-рассылку</nobr> &laquo;Медузы&raquo;. Это еще один способ оставаться с&nbsp;нами на&nbsp;связи&nbsp;&mdash; и&nbsp;получать новости, что&nbsp;бы ни&nbsp;случилось. А&nbsp;еще в&nbsp;этой рассылке мы&nbsp;рассказываем о&nbsp;блокировках и&nbsp;как можно безопасно их&nbsp;обходить. К&nbsp;сожалению, мы&nbsp;уверены, что это пригодится. <span>Защита от спама reCAPTCHA. <a href="https://policies.google.com/privacy?hl=ru" target="_blank" rel="noreferrer">Конфиденциальность</a> и&nbsp;<a href="https://policies.google.com/terms?hl=ru" target="_blank" rel="noreferrer">условия использования</a>.</span></p>`,
    success_message:
      'Мы&nbsp;отправили ссылку в&nbsp;письме на&nbsp;почту <strong>{USER_EMAIL}</strong>.<br/>Пожалуйста, перейдите по&nbsp;этой ссылке.',
    wrong_email_message: 'Ошибка! Попробуйте еще раз',
    something_wrong:
      'Что-то пошло не&nbsp;так. Напишите нам на&nbsp;<a href="mailto:meduza@meduza.io">meduza@meduza.io</a>, и&nbsp;мы&nbsp;подпишем вас',
    cta: 'Подписаться'
  },

  en: {
    hasLogo: false,
    tag: 'Newsletters',
    title: 'The Real Russia. Today.',
    text: `<p>Subscribe to Meduza’s newsletter and don’t miss the next major event <br/>in the post-Soviet region. Available everywhere with an Internet connection.<br/> <span>Protected&nbsp;by&nbsp;reCAPTCHA&nbsp;and&nbsp;the&nbsp;Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</span></p>`,
    success_message: 'Excellent! Now you’ve got to verify that email address.',
    wrong_email_message: 'Something went wrong! Try again',
    something_wrong: `Something went wrong! Please contact us at <a href="mailto:newsletter@meduza.io">newsletter@meduza.io</a>, and we'll get you signed up for our newsletter.`,
    cta: 'Subscribe'
  },

  beet: {
    hasLogo: true,
    tag: 'Newsletters',
    title: null,
    text: `<p> Underreported stories. Fresh perspectives. From&nbsp;Budapest&nbsp;to&nbsp;Bishkek.<br/> <span>Protected&nbsp;by&nbsp;reCAPTCHA&nbsp;and&nbsp;the&nbsp;Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</span></p>`,
    success_message: 'Excellent! Now you’ve got to verify that email address.',
    wrong_email_message: 'Something went wrong! Try again',
    something_wrong: `Something went wrong! Please contact us at <a href="mailto:newsletter@meduza.io">newsletter@meduza.io</a>, and we'll get you signed up for our newsletter.`,
    cta: 'Subscribe'
  }
}
